import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'
import moment from 'moment'

import EventsWrapper from 'agency/digital_renderer/components/EventsWrapper'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

const getDatePart = (event, part) => {
  if (event.dates && event.dates.date.date){
    const date = moment(event.dates.date.date, 'DD/MM/YYYY')
    if (date && part === 'month') return date.format('MMM').toUpperCase()
    if (date && part === 'day') return date.format('DD')
  }

  return ''
}

const renderEvents = events => (
  <ul className={styles.events}>
    {events.map(event => (
      <li className={styles.event} key={event.id}>
        <span className={styles.date}>
          <span className={styles.month}>{getDatePart(event, 'month')}</span>
          <span className={styles.day}>{getDatePart(event, 'day')}</span>
        </span>

        <span className={styles.title}>{event.title}</span>
      </li>
    ))}
  </ul>
)

const Timeline = ({ campaign }) => (
  <EventsWrapper
    campaign={campaign}
    render={({ events }) => (
      <div className={styles.root}>
        <ContentHolder>
          <Fade>
            <span>
              <h3 className={styles.title}>Campaign timeline</h3>

              <p>Buyers for quality property can be found all year round.</p>
              <p>
                With the marketing process having become far more sophisticated, the issue around timing is less
                critical today. The time required to sell an accurately priced property will typically vary between two
                and six weeks. Prior to launching your property to the market, allow an additional two weeks for us to
                receive the contract for sale and to prepare the marketing materials.
              </p>
              <p>Here&apos;s our proposed marketing timeline for your campaign:</p>

              {renderEvents(events)}
            </span>
          </Fade>
        </ContentHolder>
      </div>
    )}
  />
)

Timeline.propTypes = {
  campaign: PropTypes.object.isRequired,
}

export default Timeline
